import React, { Component } from 'react';
import {Subtopic, TextHolder, Footer, Button} from '../../Components/contentHolders/contentHolders.js';
import './styles.css';



export class ChapterHundredTwentyOne extends Component {

  render() {
    return (

      <section className="Content">
        <div className="content-holder">
        <div className="content-holder-inner fade">


        <Subtopic subtopicNumber={ this.props.number } subtopicTitle={ this.props.name } >

        {""}
        </Subtopic>

        <TextHolder textBigTitle="Incubators / Accelerators"/>
        <TextHolder textTitle="Indonesia"/>


                      <div className="block-outer block-outer-tableholder">
                        <div className="block-inner block-inner-tableholder">
                          <table id="t01">
                          <tbody>
                            <tr>
                              <td><a href="http://1337accelerator.com/alpha-startups/indonesia/">Alpha Startups</a></td>
                              <td>Pre-Accelerator</td>
                            </tr>
                            <tr>
                              <td><a href="https://digitaraya.com/">Digitaraya</a></td>
                              <td>Accelerator</td>
                            </tr>
                            <tr>
                              <td><a href="https://gnb.ac/">GnB Accelerator</a></td>
                              <td>Accelerator</td>
                            </tr>
                            <tr>
                              <td><a href="http://ideabox.co.id/">Ideabox Ventures</a></td>
                              <td>Accelerator</td>
                            </tr>
                            <tr>
                              <td><a href="http://dxincubator.com/">IDX Incubator</a></td>
                              <td>Incubator</td>
                            </tr>
                            <tr>
                              <td><a href="http://indigo.id/en/">Indigo Incubator</a></td>
                              <td>Incubator</td>
                            </tr>
                            <tr>
                              <td><a href="http://kolaborasi.co/">Kolaborasi</a></td>
                              <td>Incubator</td>
                            </tr>
                            <tr>
                              <td><a href="http://www.skystarventures.com/">Skystar Ventures</a></td>
                              <td>Incubator</td>
                            </tr>
                            <tr>
                              <td><a href="http://fastercapital.com/">Faster Capital (throughout SE Asia)</a></td>
                              <td>Incubator / Accelerator</td>
                            </tr>



                            </tbody>
                          </table>
                          <div className="highcharts-notes">
                            <p> </p>
                            <p> </p>
                          </div>
                      </div>

                  </div>

                  <TextHolder textTitle="Malaysia"/>


                      <div className="block-outer block-outer-tableholder">
                          <div className="block-inner block-inner-tableholder">
                              <table id="t01">
                              <tbody>
                              <tr>
                                <td><a href="http://www.1337accelerator.com/">1337 Accelerator</a></td>
                                <td>Accelerator</td>
                              </tr>
                              <tr>
                                <td><a href="http://adaptproptech.com/">ADAPT accelerator</a></td>
                                <td>Accelerator</td>
                              </tr>
                              <tr>
                                <td><a href="http://www.aseandatastartupaccelerator.com/">ASEAN Data Startup Accelerator</a></td>
                                <td>Accelerator</td>
                              </tr>
                              <tr>
                                <td><a href="expara.co">CLAS - Expara Vietnam Accelerator</a></td>
                                <td>Accelerator</td>
                              </tr>
                              <tr>
                                <td><a href="http://cyberview.com.my/industry/cyberview-living-lab/accelerator">Cyberview Living Lab Accelerator</a></td>
                                <td>Accelerator</td>
                              </tr>
                              <tr>
                                <td><a href="http://www.500distro.co/distro-dojo/">Distro Dojo</a></td>
                                <td>Accelerator</td>
                              </tr>
                              <tr>
                                <td><a href="https://www.nexea.co/accelerator-malaysia/">Nexea Accelerator/iLabs Sunway Accelerator</a></td>
                                <td>Accelerator</td>
                              </tr>
                              <tr>
                                <td><a href="https://www.sitec.com.my/sap2018/">Selangor Accelerator Programme 2018</a></td>
                                <td>Accelerator</td>
                              </tr>
                              <tr>
                                <td><a href="https://www.fintechsupercharger.com/">SuperCharger Accelerator</a></td>
                                <td>Accelerator</td>
                              </tr>
                              <tr>
                                <td><a href="https://www.aseandatastartupaccelerator.com/">The ASEAN Data Startup Accelerator</a></td>
                                <td>Accelerator</td>
                              </tr>
                              <tr>
                                <td><a href="https://mymagic.my/">The Malaysian Global Innovation and Creativity Centre (MaGIC)</a></td>
                                <td>Incubator</td>
                              </tr>
                              <tr>
                                <td><a href="http://thetunelabs.com/">Tune Labs</a></td>
                                <td>Incubator / Accelerator</td>
                              </tr>
                              <tr>
                                <td><a href="http://watchtowerfriends.com/">WatchTower and Friends Accelerator</a></td>
                                <td>Accelerator</td>
                              </tr>
                              <tr>
                                <td><a href="https://www.techstars.com/">Techstars (also in Singapore)</a></td>
                                <td>Accelerator</td>
                              </tr>
                              <tr>
                                <td><a href="http://www.accelerasia.com/">AccelerAsia (also in Singapore, Indonesia)</a></td>
                                <td>Hybrid Accelerator / BD</td>
                              </tr>





                              </tbody>
                                    </table>
                                    <div className="highcharts-notes">
                                      <p> </p>
                                      <p> </p>
                                    </div>
                                </div>

                            </div>

            <TextHolder textTitle="Philippines"/>


              <div className="block-outer block-outer-tableholder">
                  <div className="block-inner block-inner-tableholder">
                      <table id="t01">
                      <tbody>

                      <tr>
                        <td><a href="http://www.ideaspacefoundation.org/">IdeaSpace Foundation</a></td>
                        <td>Incubator / Accelerator</td>
                      </tr>
                      <tr>
                        <td><a href="https://www.launchgarage.com/">Launchgarage</a></td>
                        <td>Incubator</td>
                      </tr>
                      <tr>
                        <td><a href="http://www.startupvillage.ph/">StartUp Village</a></td>
                        <td>Incubator</td>
                      </tr>
                      <tr>
                        <td><a href="http://www.katalyst.ph/">Katalyst (also in Singapore)</a></td>
                        <td>Venture Builder</td>
                      </tr>

                        </tbody>
                            </table>
                            <div className="highcharts-notes">
                              <p> </p>
                              <p> </p>
                            </div>
                        </div>
                    </div>

          <TextHolder textTitle="Singapore"/>


              <div className="block-outer block-outer-tableholder">
                  <div className="block-inner block-inner-tableholder">
                      <table id="t01">
                      <tbody>

                      <tr>
                        <td><a href="http://www.airmaker.sg/">AIRmaker</a></td>
                        <td>Accelerator</td>
                      </tr>
                      <tr>
                        <td><a href="https://antler.co/">Antler</a></td>
                        <td>Venture Builder</td>
                      </tr>
                      <tr>
                        <td><a href="http://www.enchant.vc/">Enchant</a></td>
                        <td>Accelerator</td>
                      </tr>
                      <tr>
                        <td><a href="https://www.joinef.com/">Entrepreneur First</a></td>
                        <td>Venture Builder</td>
                      </tr>
                      <tr>
                        <td><a href="http://thefinlab.com/">FinLab Accelerator</a></td>
                        <td>Accelerator</td>
                      </tr>
                      <tr>
                        <td><a href="http://www.g2vaccelerator.com/">Get2Volume</a></td>
                        <td>Accelerator</td>
                      </tr>
                      <tr>
                        <td><a href="https://home.kpmg.com/sg/en/home/insights/2018/04/global-fintech-hackcelerator-2018.html">Global FinTech Hackcelerator</a></td>
                        <td>Accelerator</td>
                      </tr>
                      <tr>
                        <td><a href="http://www.govincapital.com/">Govin Capital</a></td>
                        <td>Accelerator</td>
                      </tr>
                      <tr>
                        <td><a href="http://www.ideawavelabs.com/">Idea Wave Labs</a></td>
                        <td>Venture Builder</td>
                      </tr>
                      <tr>
                        <td><a href="https://impacthub.ph/">Impact Hub Manila</a></td>
                        <td>Incubator</td>
                      </tr>
                      <tr>
                        <td><a href="http://incubasia-ventures.com/">IncubAsia Ventures</a></td>
                        <td>Incubator</td>
                      </tr>
                      <tr>
                        <td><a href="http://innotechventures.com/home">Innotech Ventures</a></td>
                        <td>Accelerator</td>
                      </tr>
                      <tr>
                        <td><a href="http://inspirasia.sg/">InspirAsia</a></td>
                        <td>Accelerator</td>
                      </tr>
                      <tr>
                        <td><a href="http://www.jfdi.asia/">Joyful Frog Digital Innovation</a></td>
                        <td>Accelerator</td>
                      </tr>
                      <tr>
                        <td><a href="http://www.ntuitive.sg/">NTUitive</a></td>
                        <td>Incubator</td>
                      </tr>
                      <tr>
                        <td><a href="https://www.comp.nus.edu.sg/entrepreneurship/furnace/start/">NUS Furnace</a></td>
                        <td>Incubator</td>
                      </tr>
                      <tr>
                        <td><a href="https://www.siliconstraits.com/">Silicon Straits</a></td>
                        <td>Venture Builder</td>
                      </tr>
                      <tr>
                        <td><a href="https://iie.smu.edu.sg/startups">SMU Institute of Innovation & Entrepreneurship</a></td>
                        <td>Incubator</td>
                      </tr>
                      <tr>
                        <td><a href="http://www.stream.com.sg/">Stream Global</a></td>
                        <td>Incubator</td>
                      </tr>
                      <tr>
                        <td><a href="http://www.launchpadstartups.com/">LaunchPad Malaysia (also in Malaysia)</a></td>
                        <td>Venture Builder</td>
                      </tr>
                      <tr>
                        <td><a href="https://www.apacig.com/">Asia Pacific Internet Group (also in Thailand)</a></td>
                        <td>Venture Builder</td>
                      </tr>
                      <tr>
                        <td><a href="https://impactech.com/">ImpacTech (also in Thailand)</a></td>
                        <td>Incubator</td>
                      </tr>
                      <tr>
                        <td><a href="http://sparkthailand.co/">Spark Global Acceleration Program</a></td>
                        <td>Accelerator</td>
                      </tr>
                      <tr>
                        <td><a href="https://www.bangkokbankinnohub.com/">Innohub by Bangkok Bank</a></td>
                        <td>Accelerator</td>
                      </tr>



                        </tbody>
                            </table>
                            <div className="highcharts-notes">
                              <p> </p>
                              <p> </p>
                            </div>
                        </div>
                    </div>

                    <TextHolder textTitle="Thailand"/>


                      <div className="block-outer block-outer-tableholder">
                          <div className="block-inner block-inner-tableholder">
                              <table id="t01">
                              <tbody>
                              <tr>
                                <td><a href="http://www.ais.co.th/thestartup/en/">AIS the StartUP</a></td>
                                <td>Incubator </td>
                              </tr>
                              <tr>
                                <td><a href="http://www.activator.global/">Allianz Ayudhya Activator</a></td>
                                <td>Incubator </td>
                              </tr>
                              <tr>
                                <td><a href="http://dv.co.th/">Digital Ventures</a></td>
                                <td>Incubator </td>
                              </tr>
                              <tr>
                                <td><a href="https://accelerate.dtac.co.th/en/home">Dtac Accelerate</a></td>
                                <td>Accelerator </td>
                              </tr>
                              <tr>
                                <td><a href="http://riseaccel.com/">KrungsriRISE</a></td>
                                <td>Accelerator </td>
                              </tr>
                              <tr>
                                <td><a href="http://thefinlab.com/">The FinLab</a></td>
                                <td>Accelerator </td>
                              </tr>
                              <tr>
                                <td><a href="http://www.trueincube.com/">True Incube</a></td>
                                <td>Incubator </td>
                              </tr>
                              <tr>
                                <td><a href="https://www.sciencepark.or.th/index.php/en/business-incubation-center-bic">Business Incubation Center (BIC)</a></td>
                                <td>Incubator</td>
                              </tr>
                              <tr>
                                <td><a href="https://techsauce.co/depa-accelerator/">Depa accelerator program x Techsauce</a></td>
                                <td>Accelerator</td>
                              </tr>


                                    </tbody>
                                    </table>
                                    <div className="highcharts-notes">
                                      <p> </p>
                                      <p> </p>
                                    </div>
                                </div>
                            </div>


                            <TextHolder textTitle="Vietnam"/>


                              <div className="block-outer block-outer-tableholder">
                                  <div className="block-inner block-inner-tableholder">
                                      <table id="t01">
                                      <tbody>
                                      <tr>
                                        <td><a href="http://www.viisa.vn/">Vietnam Innovative Startup Accelerator</a></td>
                                        <td>Accelerator </td>
                                      </tr>


                                            </tbody>
                                            </table>
                                            <div className="highcharts-notes">
                                              <p> </p>
                                              <p> </p>
                                            </div>
                                        </div>
                                    </div>







          <Button next={ this.props.next } buttonText= { this.props.buttonText } />
          <Footer />
          </div>
        </div>
      </section>

    );
  }
}



// WEBPACK FOOTER //
// ./src/Containers/Content/121.js